import { AxiosHttpClient } from '@/infra/http';
export const makeAxiosHttpClient = () => new AxiosHttpClient();
